import '../../css/footer.css';

const Footer = () => {
    return (
        <footer className="tamcare-footer">
            <div className="tamcare-footer-content">
                <div className="tamcare-footer-section">
                    <div className="tamcare-footer-title">
                        <img
                            src={`${process.env.PUBLIC_URL}/logo_web.png`}
                            alt="TamCare"
                            className="tamcare-brand-logo tamcare-brand-logo--footer"
                        />
                        <span className="tamcare-footer-brand-name">TÂM CARE</span>
                    </div>
                    <p className="tamcare-footer-text">
                        GCNĐKKD: 082 4599170 | PHÒNG ĐĂNG KÝ<br />
                        ĐẠI HỌC FPT - CƠ SỞ HOÀ LẠC<br />
                        KHU CÔNG NGHỆ CAO HÒA LẠC<br />
                        THẠCH THẤT, HÀ NỘI, VIỆT NAM
                    </p>
                </div>

                <div className="tamcare-footer-section">
                    <h3 className="tamcare-footer-subtitle">LIÊN HỆ</h3>
                    <p className="tamcare-footer-item">
                        <i className="fa-solid fa-location-dot"></i>
                        <span>Đại học FPT Hà Nội</span>
                    </p>
                    <p className="tamcare-footer-item">
                        <i className="fa-solid fa-phone"></i>
                        <span>Hotline: 082 4599170</span>
                    </p>
                    <p className="tamcare-footer-item">
                        <i className="fa-solid fa-envelope"></i>
                        <span>Email: tamcare.contact@gmail.com</span>
                    </p>
                    <div className="tamcare-social-links">
                        <a href="https://www.facebook.com/tamcarevn" target="_blank" rel="noreferrer" aria-label="Facebook">
                            <i className="fa-brands fa-facebook"></i>
                        </a>
                        <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
                            <i className="fa-brands fa-youtube"></i>
                        </a>
                        <a href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok">
                            <i className="fa-brands fa-tiktok"></i>
                        </a>
                    </div>
                </div>

                <div className="tamcare-footer-section">
                    <h3 className="tamcare-footer-subtitle">HỖ TRỢ 24/7</h3>
                    <p className="tamcare-footer-item">
                        <i className="fa-regular fa-clock"></i>
                        <span>Thứ 2 - Thứ 6: 08:00 - 17:00</span>
                    </p>
                    <p className="tamcare-footer-item">
                        <i className="fa-regular fa-clock"></i>
                        <span>Thứ 7 - CN: 08:00 - 11:30</span>
                    </p>
                    <div className="tamcare-footer-alert">
                        Cấp cứu khẩn cấp vui lòng gọi Hotline ngay lập tức.
                    </div>
                    <p style={{ marginTop: 16, fontSize: 13 }}>
                        <a href="/privacy" style={{ color: '#fff', marginRight: 12 }}>Chính sách bảo mật</a>
                        <a href="/terms" style={{ color: '#fff' }}>Điều khoản</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;